export const BANDED = 'BANDED';
export const BROADCAST = 'BROADCAST';
export const HAND_SPRAY = 'HAND_SPRAY';
export const HAND_DRESS = 'HAND_DRESS';

export const BANDED_DESCRIPTION = 'Banded';
export const BROADCAST_DESCRIPTION = 'Broadcast';
export const HAND_SPRAY_DESCRIPTION = 'Hand Spray';
export const HAND_DRESS_DESCRIPTION = 'Hand Dress';

export const FERTILIZER_EVENT_APPLICATION_METHOD_OPTIONS = [
    {
        key: BANDED,
        text: BANDED_DESCRIPTION,
        value: BANDED
    },
    {
        key: BROADCAST,
        text: BROADCAST_DESCRIPTION,
        value: BROADCAST
    },
    {
        key: HAND_SPRAY,
        text: HAND_SPRAY_DESCRIPTION,
        value: HAND_SPRAY
    },
    {
        key: HAND_DRESS,
        text: HAND_DRESS_DESCRIPTION,
        value: HAND_DRESS
    }
];
